import ProfitLossChart from './ProfitLossChart';

export default ProfitLossChart;
